// === Collection Modal: generiek voor alle Collectie-vakken ===
// Vervangt de oude versie die alleen werkte voor "Polaroid Extendable
// Frames". Werkt nu automatisch voor elke Collectie die je in een vak
// van de "Product/Collectie grid" sectie kiest, zonder dat je hier iets
// voor hoeft aan te passen. De sectie zet per Collectie-vak een verborgen
// <template> met de producten (titel, url, afbeelding, prijs) neer; dit
// script leest dat uit zodra je op zo'n vak klikt.
(function () {
  const modal = document.createElement('div');
  modal.id = 'lumis-collection-modal';
  modal.innerHTML = `
    <div id="lumis-modal-inner">
      <button id="lumis-modal-close">&times;</button>
      <h2 id="lumis-modal-title"></h2>
      <div id="lumis-modal-grid"></div>
    </div>
  `;
  document.body.appendChild(modal);

  const modalInner = document.getElementById('lumis-modal-inner');
  const modalClose = document.getElementById('lumis-modal-close');
  const modalTitle = document.getElementById('lumis-modal-title');
  const modalGrid = document.getElementById('lumis-modal-grid');

  function closeModal() {
    modal.classList.remove('active');
  }

  // Vult de pop-up met de producten uit het <template> dat bij het
  // aangeklikte vak hoort. Geeft true terug als er daadwerkelijk
  // producten waren om te tonen, anders false (zodat de link gewoon
  // normaal naar de collectiepagina kan doorlinken als fallback).
  function openModalFor(triggerEl) {
    const templateId = triggerEl.getAttribute('data-lumis-modal-target');
    const template = templateId ? document.getElementById(templateId) : null;
    if (!template) return false;

    const items = template.content.querySelectorAll('.lumis-modal-card-data');
    if (!items.length) return false;

    modalTitle.textContent = template.getAttribute('data-modal-title') || '';

    modalGrid.innerHTML = Array.from(items).map((item) => {
      const title = item.getAttribute('data-title') || '';
      const url = item.getAttribute('data-url') || '#';
      const image = item.getAttribute('data-image') || '';
      const price = item.getAttribute('data-price') || '';
      return `
        <a class="lumis-modal-card" href="${url}">
          <img src="${image}" alt="${title}" loading="lazy">
          <h3>${title}</h3>
          ${price ? `<p class="lumis-modal-card-price">${price}</p>` : ''}
        </a>
      `;
    }).join('');

    modal.classList.add('active');
    return true;
  }

  // Close button
  modalClose.addEventListener('click', closeModal);

  // Close on backdrop click only
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  // Stop clicks inside the inner modal from closing it or being intercepted
  modalInner.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  // Open modal when any collectie-vak (met data-lumis-modal-target) wordt aangeklikt
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-lumis-modal-target]');
    if (!trigger) return;

    const opened = openModalFor(trigger);
    if (opened) {
      e.preventDefault();
    }
    // Geen producten gevonden (leeg vak/leeg collectie)? Dan wordt e.preventDefault()
    // niet aangeroepen en linkt de <a> gewoon normaal door naar de collectiepagina.
  });
})();